import React from "react";
import Navbar from "../../../components/main/navbar";
import Footer from "../../../components/main/footer";
import { Grid2, Typography, Button } from "@mui/material";

const Recharge = () => {
  return (
    <div>
      <Navbar />
      <Grid2
        container
        justifyContent="space-evenly"
        alignItems="center"
        flexWrap="wrap"
        padding="30px"
        bgcolor="#f8f9fc"
        flexDirection="column"
      >
        <Grid2 textAlign="center" alignItems="center" marginBottom="20px">
          <Typography variant="body2" fontWeight="700" fontSize="30px">
            Comment recharger ses crédits 💵
          </Typography>
        </Grid2>

        <iframe
          width="100%"
          height="300px"
          src="https://www.youtube.com/embed/FIUHYJTEaEQ"
          title="How to recharge your credits"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            maxWidth: "1000px",
            borderRadius: "8px",
          }}
        ></iframe>
        <Grid2 container justifyContent="center" width="300px">
          <Button
          fullWidth
            href="/login"
            variant="contained"
            sx={{
              mt: 3,
              mb: 2,
              color:"white",
              backgroundColor: "#146aff",
              "&:hover": { backgroundColor: "#004aad" },
            }}
          >
            Se connecter
          </Button>
        </Grid2>
      </Grid2>

      <Footer />
    </div>
  );
};

export default Recharge;
